import {Drawer, Button} from 'antd';
import React, {Component} from 'react';
import API from "../../Utils/API";
import NotificationUtil from "../../Utils/NotificationUtil";
import {SiteForm} from "./SiteForm";

class SiteDrawer extends Component {

    save = (e) => {
        const { form } = this.formRef.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            console.log(values);
            API.post("/settings/saveSite", values)
                .then(res => {
                    form.resetFields();
                    this.props.onClose(e,true);
                    NotificationUtil(res.data);
                }).catch(error => {
                NotificationUtil({msg:"Hiba történt!" + error,type:"error"});
                this.props.onClose(e,true);
            });
        });
    };

    constructor(props){
        super(props);
        this.state = {
            site : {siteTitle : ""},
            title: ""
        };
    }

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    open = () => {
        if(this.props.editId !== "") {
            API.get("/settings/getSite/" + this.props.editId).then(res => {
                this.setState({site: res.data});
                this.setState({title: "Telephely módosítása : "+ res.data.title});
            });
        }else{
            this.setState({site: {siteTitle : ""}});
            this.setState({title: "Új telephely felvétele"});
        }
    };

    render() {
        return (
            <Drawer
                destroyOnClose={true}
                width={480}
                title={this.state.title}
                placement="right"
                closable={true}
                afterVisibleChange={this.open}
                onClose={this.props.onClose}
                visible={this.props.visible}
            >

                <SiteForm {...this.state.site} wrappedComponentRef={this.saveFormRef} initialName={this.state.site.siteTitle}/>
                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                    }}
                >
                    <Button onClick={this.props.onClose} style={{marginRight: 8}}>
                        Mégsem
                    </Button>
                    <Button onClick={this.save} type="primary">
                        Mentés
                    </Button>
                </div>
            </Drawer>
        );
    }
}

export default SiteDrawer;

